export default __webpack_public_path__ + "static/media/MarketShare.0442d24b.png";